import * as React from "react";
import * as eventService from "../../models/services/eventService";
import { Translations } from "ui/Scripts/source/models/translations";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { Base } from "ui/Scripts/source/framework/base";
import { IEventHandler } from "../../models/event/eventHandler";
import { Button } from "ui/Scripts/source/components/framework/button";
import { SelectUserDialog } from "../framework/selectUserDialog";
import { IUserListItem, UserListItem } from "../../models/user/userListItem";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { IEventMessage } from "../../models/event/eventMessage";
import { ListLine } from "../framework/listLine";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { AppUtils } from "../../framework/appUtils";

//EventHandlerListMenu
export interface IEventHandlerListMenuProp {
    onRemove: () => void;
    onCancel: () => void;
}

export class EventHandlerListMenu extends React.Component<IEventHandlerListMenuProp, {}> {
    handleRemoveClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRemove();
    };

    handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    };
        
    render() {
        return (
            <div className="listPopupMenu" onClick={this.handleCancelClick}>
                <div className="menu">
                    <div className="line" onClick={this.handleRemoveClick}>{Translations.Remove}</div>
                    <div className="line" onClick={this.handleCancelClick}>{Translations.Cancel}</div>
                </div>
            </div>
        );
    }
}

//EventHandlerListTitleRow
//***************************************************************
export class EventHandlerListTitleRow extends React.Component<{}, {}> {
    render() {
        return (
            <div className="fullLeft lineContainer">
                <div className="line title">
                    <div className="row">
                        <div className="col-8">{Translations.EventHandler}</div>
                        <div className="col-4 ra">{Translations.Approval}</div>
                    </div>
                </div>
            </div>
        );
    }
}

//EventHandlerListLine
//***************************************************************
export interface IEventHandlerListLineProp {
    userCode: string;
    eventHandler: IEventHandler;
    selectedId: string;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onApproveClick: () => void;
}

export class EventHandlerListLine extends React.Component<IEventHandlerListLineProp, {}> {
    render() {
        const props = this.props;
        const eventHandler = props.eventHandler;
        const currentUser = props.userCode === eventHandler.userCode;
        const approved = !Base.isNullOrUndefined(eventHandler.approveDate);
        return (
            <ListLine
                id={props.eventHandler.id}
                first={false}
                selected={props.selectedId === props.eventHandler.id}
                classes={"line"}
                onClick={props.onClick}
                onLongPress={props.onLongPress}
                onRefreshList={null}>
                <div className="row">
                    <div className={"col" + (approved ? " col-8" : (currentUser ? " col-8" : " col-12"))}>
                        <AvatarImage
                            classes="leftDataCont"
                            name={eventHandler.userName}
                            image={eventHandler.userPicture}
                        />
                        <div className="dataCont rightAvatar">
                            <div className="singleLine">{eventHandler.userName}</div>
                        </div>
                    </div>
                    {approved &&
                        <div className="col col-4 ra"><span className="es s2">{Base.timeToDateStr(eventHandler.approveDate)}</span></div>
                    }
                    {currentUser && !approved &&
                        <div className="col col-4 ra">
                            <Button
                                buttonType={DialogButtonType.Default}
                                title={Translations.Approve}
                                onClick={props.onApproveClick}
                            />
                        </div>
                    }
                </div>
            </ListLine>
        );
    }
}

//EventHandlerList
//***************************************************************
export interface IEventHandlerListProp {
    isReadOnly: boolean;
    isClosed: boolean;
    unitId: string;
    userCode: string;
    eventCreateUserCode: string;
    eventHandlers: IEventHandler[];
    messages: IEventMessage[];
    noHandlersMessage?: string;
    onRemoveEventHandler: (id: string) => void;
    onAddEventHandlers: (users: IUserListItem[]) => void;
    onApproveEventHandler: () => void;
}

interface IEventHandlerListState {
    selectedId: string;
    showListMenu: boolean;
    showSelectUserDialog: boolean;
}

export class EventHandlerList extends React.Component<IEventHandlerListProp, IEventHandlerListState> {
    constructor(props) {
        super(props);
        this.state = { selectedId: null, showListMenu: false, showSelectUserDialog: false };
    }
    
    handleLineClick = (id: string) => {
        this.setState({
            selectedId: id
        });
    };

    //#region Adding
    handleAddClick = () => {
        this.setState({ showSelectUserDialog: true });
    };

    handleLoadUsers = (page: number): Promise<IEndlessList<UserListItem>> => {
        return AppUtils.callService(() => eventService.getUserList(this.props.unitId, page, this.props.eventHandlers.map(i => i.userCode)));
    };

    handleSelectUserDialogOk = (users: IUserListItem[]) => {
        this.props.onAddEventHandlers(users);
        this.setState({
            showSelectUserDialog: false
        });
    };

    handleSelectUserDialogCancel = () => {
        this.setState({
            showSelectUserDialog: false
        });
    };
    //#endregion

    //#region Approval
    handleApproveClick = () => {
        this.props.onApproveEventHandler();
    };
    //#endregion

    handleLineLongPress = (id: string) => {
        this.setState({
            selectedId: id,
            showListMenu: true
        });
    };

    handleMenuRemove = () => {
        const selectedId = this.state.selectedId;
        if (Base.isNullOrEmpty(selectedId)) return;
        this.props.onRemoveEventHandler(selectedId);
        this.setState({
            showListMenu: false
        });
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        const eventHandlers = props.eventHandlers;
        const selectedEventHandler = eventHandlers.find(i => i.id === state.selectedId);
        const canRemove = !Base.isNullOrUndefined(selectedEventHandler) && Base.isNullOrUndefined(selectedEventHandler.approveDate) &&
            Base.isNullOrUndefined(props.messages.find(i => i.modifyUserCode === selectedEventHandler.userCode));
            
        console.log(props.noHandlersMessage, props.eventHandlers.length, props.noHandlersMessage && eventHandlers?.length === 0);
        return (
            <div>
                <div className="fullLeft">
                    <ToolButton
                        tooltip={Translations.Add}
                        disabled={props.isReadOnly || props.isClosed}
                        classes={"round right mono add"}
                        onClick={this.handleAddClick}/>
                </div>
                {!props.isReadOnly && eventHandlers.length === 0 &&
                    <div className="fullLeft">
                        <div className="alert alert-info" role="alert">
                            {Translations.AddEventHandlersToEvent}
                        </div>
                    </div>
                }
                <EventHandlerListTitleRow />
                {eventHandlers.length > 0 &&
                    <div className="fullLeft lineContainer eventHandlers">
                        {(props.noHandlersMessage && eventHandlers?.length === 0) && (
                            <div className="alert alert-info" role="alert">
                                {props.noHandlersMessage}
                            </div>
                        )}
                        {eventHandlers.map((eventHandler) =>
                            <EventHandlerListLine
                                key={eventHandler.id}
                                userCode={props.userCode}
                                selectedId={state.selectedId}
                                eventHandler={eventHandler}
                                onClick={this.handleLineClick}
                                onLongPress={!props.isReadOnly && !props.isClosed && canRemove ? this.handleLineLongPress : null}
                                onApproveClick={this.handleApproveClick}
                            />
                        )}
                    </div>
                }
                {state.showListMenu &&
                    <EventHandlerListMenu
                        onRemove={this.handleMenuRemove}
                        onCancel={this.handleMenuCancel}
                    />
                }
                {state.showSelectUserDialog &&
                    <SelectUserDialog
                        title={Translations.SelectEventHandler}
                        loadUsers={this.handleLoadUsers}
                        multiSelect={true}
                        onOk={this.handleSelectUserDialogOk}
                        onCancel={this.handleSelectUserDialogCancel}
                    />
                }
            </div>
        );
    }
}